import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import PageLayout from "../../containers/Layout/PageLayout.jsx";
import FreelancePage from "../../../shared/components/Styled/Containers/FreelancePage.jsx";

const MustBeAdminOrBmOrCompletedFreelance = function (Component, pageLayoutWrapper = true) {
  let MustBeAdminOrBmOrCompletedFreelanceComponent = (props) => {
    const {loading, isAdmin, isBusinessManager, isComplete, ...rest} = props;

    if (loading) {
      return null;
    }

    if (!isAdmin && !isBusinessManager && !isComplete) {
      const content = <Fragment>
        <h2 className="text-center">
          Impossible d'accéder à ce contenu
        </h2>
        <p className="text-center mb-5">
          Vous devez être connecté en tant qu'Admin ou Business Manager ou être freelance avec un profil complet pour
          pouvoir accéder a cette page.
        </p>
      </Fragment>
      return (pageLayoutWrapper)
        ? <PageLayout>{content}</PageLayout>
        : <FreelancePage>{content}</FreelancePage>;
    }

    return <Component {...rest}/>;
  };

  return connect(
    state => ({
      loading: state.currentUser?.loading,
      isAdmin: state.currentUser?.user?.isAdmin,
      isBusinessManager: state.currentUser?.user?.isBusinessManager,
      isComplete: state.currentUser?.user?.complete,
    })
  )(MustBeAdminOrBmOrCompletedFreelanceComponent);
};

export default MustBeAdminOrBmOrCompletedFreelance;